function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
import { loginObj } from '@/services/base';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['chatbot']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':5000')
  });
} else {
  appApisGTW = axios.create({
    // baseURL: 'https://dev-itcbi-matilliondev-run-usct1-temp-qmuzefzuga-uc.a.run.app'.replace('{PORT}', ':8000')
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000') //process.env.VUE_APP_CR_CHATBOT_DATACENTER //process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var MODULE = "/api/chatbotmngt-datacenter";
var CONTROLLER = "/datastore";
export default {
  getAll: function getAll() {
    tasks.lockScreen.lock();
    return appApisGTW.get(MODULE + CONTROLLER + "").then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get: function get(id) {
    tasks.lockScreen.lock();
    return appApisGTW.get(MODULE + CONTROLLER + "/".concat(id)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  create: function create(formData) {
    tasks.lockScreen.lock();
    return appApisGTW.post(MODULE + CONTROLLER + "", formData).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update: function update(id, formData) {
    tasks.lockScreen.lock();
    return appApisGTW.put(MODULE + CONTROLLER + "/".concat(id), formData).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  delete: function _delete(id) {
    tasks.lockScreen.lock();
    return appApisGTW.delete(MODULE + CONTROLLER + "/".concat(id)).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get_file_rows: function get_file_rows(datacenter_id, file_id) {
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
    var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    tasks.lockScreen.lock();
    var url = MODULE + CONTROLLER + "/".concat(datacenter_id, "/").concat(file_id);
    var params = [];
    if (query) {
      params.push("query=".concat(encodeURIComponent(query)));
    }
    if (limit) {
      params.push("limit=".concat(limit));
    }
    if (page) {
      params.push("page=".concat(page));
    }
    if (params.length > 0) {
      url += "?".concat(params.join('&'));
    }
    return appApisGTW.get(url).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update_row: function update_row(row_id, datacenter_id, file_id, data) {
    var body = _objectSpread({}, data);
    tasks.lockScreen.lock();
    var url = MODULE + CONTROLLER + "/".concat(file_id, "/").concat(datacenter_id, "/").concat(row_id);
    return appApisGTW.post(url, body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};